import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MARKETPLACE_MATOMO_EVENT_CATEGORY_PAYMENT, PaymentMethodType } from '@platform-frontend/marketplace';

@Component({
  selector: 'yat-add-new-payment-method-button',
  templateUrl: './add-new-payment-method-button.component.html',
  styleUrls: ['./add-new-payment-method-button.component.scss']
})
export class AddNewPaymentMethodButtonComponent {
  @Input()
  id: string;

  @Input()
  isSelected: boolean = false;

  @Input()
  paymentMethodType: PaymentMethodType;

  @Input()
  matomoEventClickAction: string;

  @Output()
  clickMethod = new EventEmitter<PaymentMethodType>();

  @Output()
  focusEvent = new EventEmitter<FocusEvent>();

  readonly MATOMO_EVENT_CATEGORY_PAYMENT = MARKETPLACE_MATOMO_EVENT_CATEGORY_PAYMENT;

  selectPaymentMethod(type: PaymentMethodType): void {
    this.clickMethod.emit(type);
  }

  onFocus(event: FocusEvent): void {
    this.focusEvent.emit(event);
  }
}
